import React from "react";
import Grid2 from "@mui/material/Unstable_Grid2";

import useWindowDimensions from "../hooks/useWindowDimensions";
import useTheme from "../hooks/useTheme";
import { FilterType } from "../types/types";
import AllFilter from "./allFilter";
import ERPFilterButtons from "./ERPFilterButtons";
import PlatformFilterButtons from "./PlatformFilterButtons";

export default function Header(props: {
  filter: FilterType;
  setFilter: (f: FilterType) => void;
}) {
  const { isSmallLayout, isMediumLayout } = useWindowDimensions();
  const theme = useTheme();

  const onChange = (newFilter: FilterType) =>
    props.setFilter({ ...props.filter, ...newFilter });

  const styles: {
    container: React.CSSProperties;
    filter: React.CSSProperties;
    item: React.CSSProperties;
  } = {
    container: {
      backgroundColor: theme.background,
      paddingTop: 15,
      paddingBottom: 15,
    },
    item: {
      padding:
        isSmallLayout || isMediumLayout ? "2px 0px 2px 0px" : "0px 5px 0px 5px",
    },
    filter: {
      display: "flex",
      //justifyContent: "space-between",
      flexDirection: isSmallLayout || isMediumLayout ? "column" : "row",
      alignItems: isSmallLayout || isMediumLayout ? "center" : "end",
    },
  };

  return (
    <div style={styles.container}>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            width: isSmallLayout || isMediumLayout ? "100%" : "70%",
          }}
        >
          <Grid2
            container
            alignItems="center"
            flexDirection={isSmallLayout || isMediumLayout ? "column" : "row"}
          >
            <Grid2
              xs
              display="flex"
              justifyContent={isSmallLayout ? "center" : "flex-start"}
            >
              <a
                href="https://www.infominds.eu/"
                target="_blank"
                rel="noreferrer"
                style={styles.item}
              >
                <img
                  src={theme.images.logo}
                  style={{
                    height: 82,
                  }}
                  alt="logo"
                />
              </a>
            </Grid2>

            <Grid2 xs>
              <div style={styles.filter}>
                <AllFilter
                  filter={props.filter}
                  onChange={onChange}
                  style={styles.item}
                />
                <ERPFilterButtons
                  filter={props.filter}
                  onChange={onChange}
                  style={styles.item}
                />
                <PlatformFilterButtons
                  filter={props.filter}
                  onChange={onChange}
                  style={styles.item}
                />
              </div>
            </Grid2>
          </Grid2>
        </div>
      </div>
    </div>
  );

  /* const styles: {
    header: React.CSSProperties;
    item: React.CSSProperties;
    filter: React.CSSProperties;
  } = {
    header: {
      display: "flex",
      backgroundColor: theme.headerBackground,
      padding: 20,
      justifyContent: "space-between",
      flexDirection: isSmallLayout || isMediumLayout ? "column" : "row",
      alignItems: isSmallLayout || isMediumLayout ? "center" : "end",
    },
    item: { padding: "0px 0px 0px 0px" },
    filter: {
      display: "flex",
      justifyContent: "space-between",
      flexDirection: isSmallLayout || isMediumLayout ? "column" : "row",
      alignItems: isSmallLayout || isMediumLayout ? "center" : "end",
    },
  };

  return (
    <div style={styles.header}>
      <div style={styles.item}>
        <a href="https://www.infominds.eu/" target="_blank" rel="noreferrer">
          <img
            src="./images/logoinfominds.png"
            style={{
              height: 82,
            }}
            alt="logo"
          />
        </a>
      </div>

      <div style={styles.filter}>
        <AllFilter
          filter={props.filter}
          onChange={onChange}
          style={styles.item}
        />
        <ERPFilterButtons
          filter={props.filter}
          onChange={onChange}
          style={styles.item}
        />
        <PlatformFilterButtons
          filter={props.filter}
          onChange={onChange}
          style={styles.item}
        />
      </div>
    </div>
  ); */
}
